import React from 'react';

const ModelStrengthsTab = ({ 
  getModelStrengths,
  getScoreColor,
  formatTaskName
}) => {
  return (
    <div className="space-y-6">
      {getModelStrengths().filter(model => model.model.includes('ASI-1')).map((modelStrength) => (
        <div key={modelStrength.model} className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h2 className="text-lg font-semibold mb-2 text-center sm:text-left">{modelStrength.model}</h2>
          <div className="text-sm mb-3 text-center sm:text-left">Best performance in {modelStrength.count} tasks</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {modelStrength.tasks
              .sort((a, b) => b.score - a.score)
              .map((task, idx) => (
                <div key={idx} className={`p-3 rounded ${getScoreColor(task.score)} text-center sm:text-left`}>
                  <div className="font-medium">{formatTaskName(task.name)}</div>
                  <div className="text-sm mt-1">{task.score}%</div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ModelStrengthsTab;
